import { View } from 'components';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

/**
 * DndBackend
 *
 * @return {JSX.Element}
 */
const DndBackend = ({ onMove, children, className }) => {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    onMove(result.source.index, result.destination.index);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="list" direction="horizontal">
        {(provided) => (
          <View
            className={className}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {children}
            {provided.placeholder}
          </View>
        )}
      </Droppable>
    </DragDropContext>
  );
};

DndBackend.displayName = 'DndBackend';

export default DndBackend;
